export enum ChangeOrderStatus {
  DRAFT = 'DRAFT',
  IN_VALIDATION = 'IN_VALIDATION',
  VALIDATION_FAILED = 'VALIDATION_FAILED',
  VALIDATION_PASSED = 'VALIDATION_PASSED',
  REJECTED = 'REJECTED',
  REWORK = 'REWORK',
  PENDING_REVIEW = 'PENDING_REVIEW',
  PENDING_REALLOCATION = 'PENDING_REALLOCATION',
  PENDING_PR = 'PENDING_PR',
  PENDING_PO = 'PENDING_PO',
  RESOLVED = 'RESOLVED',
}

export enum ChangeOrderType {
  RFQ = 'RFQ',
  PAC_NON_RFQ = 'PAC_NON_RFQ',
}

export enum ChangeOrderFileStatus {
  UPLOADED = 'UPLOADED',
  PROCESSING = 'PROCESSING',
  FILE_SCANNING_FAILED = 'FILE_SCANNING_FAILED',
  VALIDATION_FAILED = 'VALIDATION_FAILED',
  VALIDATION_PASSED = 'VALIDATION_PASSED'
}

export interface Documents {
  inputFiles?: S3File[];
  quoteFile?: S3File;
  additionalFiles?: S3File[];
}

export interface S3File {
  name: string;
  errorFile?: string;
  status: ChangeOrderFileStatus;
  createdAt: string;
}

export interface ChangeOrderGeneralInformation {
  description: string;
  poIds: string[];
  reasonForChange: string;
  otherReasonForChange?: string;
  requesterEmail: string;
  fbns: string[];
  workPerformed: boolean;
  osdImpact: boolean;
  expectedDeliveryDate?: string;
  osdImpactComments?: string;
  gcm?: string;
}

export interface ChangeOrderForm {
  status: ChangeOrderStatus;
  changeOrderType: ChangeOrderType;
  changeOrderId: string;
  rfqResponseId: string;
  rfqRevision: number;
  businessId: string;
  generalInformation: ChangeOrderGeneralInformation;
  documents?: Documents;
}
